import { render, staticRenderFns } from "./ResultsList.vue?vue&type=template&id=65717f5b&scoped=true&class=results-list"
import script from "./ResultsList.vue?vue&type=script&lang=js"
export * from "./ResultsList.vue?vue&type=script&lang=js"
import style0 from "./ResultsList.vue?vue&type=style&index=0&id=65717f5b&prod&lang=scss"
import style1 from "./ResultsList.vue?vue&type=style&index=1&id=65717f5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65717f5b",
  null
  
)

export default component.exports